Office.onReady((info) => {
	if (info.host === Office.HostType.Outlook) 
	{
		// Initialize saveSettings button
		let buttonSave = document.getElementById("saveSettings");
		buttonSave.onclick = saveToLocalStorage;

		// Initialize saveBoardSettings button
		let buttonBoardSave = document.getElementById("saveBoardSettings");
		buttonBoardSave.onclick = saveBoardSettingsToLocalStorage;

		// Get values from localStorage
		if(localStorage.getItem('subdomain') != '') document.getElementById("subdomain").value = localStorage.getItem('subdomain');
		if(localStorage.getItem('apikey') != '') document.getElementById("APIKey").value = localStorage.getItem('apikey');

		if(localStorage.getItem('boards') != null && localStorage.getItem('boards') != '') 
		{
			const boards = JSON.parse(localStorage.getItem('boards'));
			const selectedBoardId = localStorage.getItem('boardId');
			const boardSelector = document.getElementById("boardId");
			boardSelector.disabled = false;
			boardSelector.options.length = 0;

			// Add one empty option
			let newOption = new Option("Please select board", -1);	
			boardSelector.appendChild(newOption);	

			for (const board_id in boards) {
				let selected = false;
				if(board_id == selectedBoardId)	selected = true;
				let newOption = new Option(boards[board_id], board_id, false, selected);	
				boardSelector.appendChild(newOption);	
				
			}	
		}
		
		if(localStorage.getItem('boardStructure') != null && localStorage.getItem('boardStructure') != '')
		{
			const workflows = JSON.parse(localStorage.getItem('boardStructure'));
			const selectedWorkflowId = localStorage.getItem('workflowId');
			const selectedColumnId = localStorage.getItem('columnId');
			const selectedLaneId = localStorage.getItem('laneId');
			const owners = JSON.parse(localStorage.getItem('owners'));
			const selectedOwnerId = localStorage.getItem('ownerId');

			const workflowSelector = document.getElementById("workflowId");
			workflowSelector.disabled = false;
			workflowSelector.options.length = 0;

			for (const workflow_id in workflows) {
				let selected = false;
				if(workflow_id == selectedWorkflowId) selected = true;
				let newOption = new Option(workflows[workflow_id]["name"], workflow_id, false, selected);	
				workflowSelector.appendChild(newOption);						
			}
			
			const columnSelector = document.getElementById("columnId");
			columnSelector.disabled = false;
			columnSelector.options.length = 0;

			const columns = workflows[selectedWorkflowId]["columns"];
			for (const column_id in columns) {
				let selected = false;
				if(column_id == selectedColumnId) selected = true;				
				let newOption = new Option(columns[column_id], column_id, false, selected);	
				columnSelector.appendChild(newOption);						
			}

			const laneSelector = document.getElementById("laneId");
			laneSelector.disabled = false;
			laneSelector.options.length = 0;

			const lanes = workflows[selectedWorkflowId]["lanes"];
			for (const lane_id in lanes) {
				let selected = false;
				if(lane_id == selectedLaneId) selected = true;				
				let newOption = new Option(lanes[lane_id], lane_id, false, selected);	
				laneSelector.appendChild(newOption);						
			}

			const ownerSelector = document.getElementById("ownerId");
			ownerSelector.disabled = false;
			ownerSelector.options.length = 0;

			// Add one empty option
			let newOption = new Option("not set", 0);	
			ownerSelector.appendChild(newOption);	

			for (const owner_id in owners) {
				let selected = false;
				if (owner_id == selectedOwnerId) selected = true;
				let newOption = new Option(owners[owner_id], owner_id, false, selected);
				ownerSelector.appendChild(newOption);
			}
		}

		// Click view password icon
		let viewPassword = document.getElementById("viewPassword");
		viewPassword.onclick = toggleAPIKeyView;

		// Click hide password icon
		let hidePassword = document.getElementById("hidePassword");
		hidePassword.onclick = toggleAPIKeyHide;
		hidePassword.style.display = 'none';
	}
});

function saveToLocalStorage() 
{
	let buttonSave = document.getElementById("saveSettings");
	buttonSave.style.display = "none"; 

	showMessage("connMessageBox", "clear", " ", "block", "connMessage");	

	const subdomain = document.getElementById("subdomain").value;
	const apikey    = document.getElementById("APIKey").value;

	localStorage.setItem('subdomain', subdomain);
	localStorage.setItem('apikey', apikey);

	if(subdomain != '' && apikey != '')
	{
		let xhttp = new XMLHttpRequest();
		let url = glb_baseURL + "boards.php";

		xhttp.open("GET", url, true);
		xhttp.setRequestHeader("Content-type", "application/json");
		xhttp.setRequestHeader("subdomain", subdomain);
		xhttp.setRequestHeader("apikey", apikey);

		xhttp.onreadystatechange = function() {
			if (xhttp.readyState === XMLHttpRequest.DONE) {
				const status = xhttp.status;
				const response = JSON.parse(xhttp.responseText);
				if (status == 200) 
				{
					if(response.code == '200')
					{
						// Boards loaded
						localStorage.setItem('boards',  JSON.stringify(response.data));

						const boardSelector = document.getElementById("boardId");
						boardSelector.disabled = false;
						boardSelector.options.length = 0;

						// Add one empty option
						let newOption = new Option("Please select board", -1);	
						boardSelector.appendChild(newOption);	
						
						boards = response.data;
						for (const board_id in boards) {
							let newOption = new Option(boards[board_id], board_id);	
							boardSelector.appendChild(newOption);	
						}	
												
						// Reset all drop downs
						const workflowSelector = document.getElementById("workflowId");
						workflowSelector.options.length = 0;						
						workflowSelector.disabled = true;
						
						const columnSelector = document.getElementById("columnId");
						columnSelector.options.length = 0;
						columnSelector.disabled = true;

						const laneSelector = document.getElementById("laneId");
						laneSelector.options.length = 0;
						laneSelector.disabled = true;

						const ownerSelector = document.getElementById("ownerId");
						ownerSelector.options.length = 0;
						ownerSelector.disabled = true;

						showMessage("connMessageBox", "success", "Connection settings saved.", "block", "connMessage");	

					} else {
						// There has been an error with the request
						const error = response.error;
						showMessage("connMessageBox", "error",  "Businessmap error: " + error, "block", "connMessage");	
					}

				} else {
					// There has been an error with the request
					const error = response.error;
					showMessage("connMessageBox", "error",  "Businessmap error: " + error, "block", "connMessage");	
				}
			}
		};

		xhttp.send();	
		
	} else {
		showMessage("connMessageBox", "error",  "Please enter connection settings", "block", "connMessage");		
	}

	
	setTimeout(function (){
		document.getElementById("connMessageBox").style.display = 'none';
		buttonSave.style.display = "inline"; 
	}, 4000);	
}

function toggleAPIKeyView()
{
	document.getElementById('APIKey').type = 'text';
	document.getElementById("viewPassword").style.display = 'none';
	document.getElementById("hidePassword").style.display = 'inline';
}

function toggleAPIKeyHide()
{
	document.getElementById('APIKey').type = 'password';
	document.getElementById("viewPassword").style.display = 'inline';
	document.getElementById("hidePassword").style.display = 'none';
}

function loadWorkflows(e) 
{
	let buttonSave = document.getElementById("saveBoardSettings");
	buttonSave.style.display = "none"; 

	showMessage("messageBox", "clear",  " ", "block", "message");		

	const subdomain = document.getElementById("subdomain").value;
	const apikey    = document.getElementById("APIKey").value;

	if(subdomain != '' && apikey != '')
	{
		let selectedBoard = (e.value || e.options[e.selectedIndex].value);

		if(selectedBoard == -1)
		{
			showMessage("messageBox", "error",  "Please select board", "block", "message");		

			const workflowSelector = document.getElementById("workflowId");
			workflowSelector.disabled = true;
			workflowSelector.options.length = 0;

			const columnSelector = document.getElementById("columnId");
			columnSelector.disabled = true;
			columnSelector.options.length = 0;

			const laneSelector = document.getElementById("laneId");
			laneSelector.disabled = true;
			laneSelector.options.length = 0;		
			
			const ownerSelector = document.getElementById("ownerId");
			ownerSelector.disabled = true;
			ownerSelector.options.length = 0;

		} else {

			let xhttp = new XMLHttpRequest();
			let url = glb_baseURL + "structure.php?board_id=" + selectedBoard;
			xhttp.open("GET", url, true);
			xhttp.setRequestHeader("Content-type", "application/json");
			xhttp.setRequestHeader("subdomain", subdomain);
			xhttp.setRequestHeader("apikey", apikey);

			xhttp.onreadystatechange = function() {
				if (xhttp.readyState === XMLHttpRequest.DONE) {
					const status = xhttp.status;
					const response = JSON.parse(xhttp.responseText);

					if (status == 200) 
					{
						if(response.code == '200')
						{
							// Board structure loaded
							localStorage.setItem('boardStructure',  JSON.stringify(response.data));

							const workflowSelector = document.getElementById("workflowId");
							workflowSelector.disabled = false;
							workflowSelector.options.length = 0;

							let firstWorkflowId = 0;							
							const workflows = response.data;
							for (const workflow_id in workflows) {
								if( firstWorkflowId == 0 ) firstWorkflowId = workflow_id;
								let newOption = new Option(workflows[workflow_id]["name"], workflow_id);	
								workflowSelector.appendChild(newOption);						
							}
							
							const columnSelector = document.getElementById("columnId");
							columnSelector.disabled = false;
							columnSelector.options.length = 0;

							const columns = workflows[firstWorkflowId]["columns"];
							for (const column_id in columns) {
								let newOption = new Option(columns[column_id], column_id);	
								columnSelector.appendChild(newOption);						
							}

							const laneSelector = document.getElementById("laneId");
							laneSelector.disabled = false;
							laneSelector.options.length = 0;

							const lanes = workflows[firstWorkflowId]["lanes"];
							for (const lane_id in lanes) {
								let newOption = new Option(lanes[lane_id], lane_id);	
								laneSelector.appendChild(newOption);						
							}
							
							loadOwners(e, selectedBoard);

							showMessage("messageBox", "success",  "Workflows loaded", "block", "message");

						} else {
							// There has been an error with the request
							const error = response.error;
							showMessage("messageBox", "error",  "Businessmap error: " + error, "block", "message");
						}

					} else {
						// There has been an error with the request
						const error = response.error;
						showMessage("messageBox", "error",  "Businessmap error: " + error, "block", "message");
					}
				}
			};

			xhttp.send();	
		}
	} else {
		showMessage("messageBox", "error",  "Please enter connection settings", "block", "message");
	}

	setTimeout(function (){
		document.getElementById("messageBox").style.display = 'none';
		buttonSave.style.display = "inline"; 
	}, 3000);	
}

function loadColumnsAndLanes(e) 
{
	const workflows = JSON.parse(localStorage.getItem('boardStructure'));

	const columnSelector = document.getElementById("columnId");
	columnSelector.options.length = 0;

	let selectedWorkflowId = (e.value || e.options[e.selectedIndex].value);
	const columns = workflows[selectedWorkflowId]["columns"];
	for (const column_id in columns) {
		let newOption = new Option(columns[column_id], column_id);	
		columnSelector.appendChild(newOption);						
	}

	const laneSelector = document.getElementById("laneId");
	laneSelector.options.length = 0;

	const lanes = workflows[selectedWorkflowId]["lanes"];
	for (const lane_id in lanes) {
		let newOption = new Option(lanes[lane_id], lane_id);	
		laneSelector.appendChild(newOption);						
	}
}

function loadOwners(e, selectedBoard) 
{
	const subdomain = document.getElementById("subdomain").value;
	const apikey    = document.getElementById("APIKey").value;

	let xhttp = new XMLHttpRequest();
	let url = glb_baseURL + "users.php?board_id=" + selectedBoard;
	xhttp.open("GET", url, true);
	xhttp.setRequestHeader("Content-type", "application/json");
	xhttp.setRequestHeader("subdomain", subdomain);
	xhttp.setRequestHeader("apikey", apikey);

	xhttp.onreadystatechange = function() {
		if (xhttp.readyState === XMLHttpRequest.DONE) {
			const status = xhttp.status;
			const response = JSON.parse(xhttp.responseText);

			if (status == 200) 
			{
				if(response.code == '200')
				{
					// Owners loaded
					localStorage.setItem('owners',  JSON.stringify(response.data));

					const ownerSelector = document.getElementById("ownerId");
					ownerSelector.disabled = false;
					ownerSelector.options.length = 0;

					// Add one empty option
					let newOption = new Option("Not Set", 0);	
					ownerSelector.appendChild(newOption);	

					let firstOwnerId = 0;							
					const owners = response.data;
					for (const owner_id in owners) {
						if( firstOwnerId == 0 ) firstOwnerId = owner_id;
						let newOption = new Option(owners[owner_id], owner_id);	
						ownerSelector.appendChild(newOption);						
					}
							
				} else {
					// There has been an error with the request
					const error = response.error;
					showMessage("messageBox", "error",  "Businessmap error: " + error, "block", "message");
				}

			} else {
				// There has been an error with the request
				const error = response.error;
				showMessage("messageBox", "error",  "Businessmap error: " + error, "block", "message");
			}
		}
	};

	xhttp.send();	
}

function saveBoardSettingsToLocalStorage() 
{
	let buttonBoardSettingsSave = document.getElementById("saveBoardSettings");
	buttonBoardSettingsSave.style.display = "none"; 

	showMessage("messageBox", "clear",  " ", "block", "message");

	if(document.getElementById("boardId").value == -1)
	{
		showMessage("messageBox", "error",  "Please select board.", "block", "message");

	} else {
		localStorage.setItem('boardId', 	document.getElementById("boardId").value);
		localStorage.setItem('workflowId',  document.getElementById("workflowId").value);
		localStorage.setItem('columnId', 	document.getElementById("columnId").value);
		localStorage.setItem('laneId', 		document.getElementById("laneId").value);
		localStorage.setItem('ownerId', 	document.getElementById("ownerId").value);

		showMessage("messageBox", "success",  "Board settings saved.", "block", "message");
	}

	setTimeout(function (){
		document.getElementById("messageBox").style.display = 'none';
		buttonBoardSettingsSave.style.display = "inline"; 
	}, 3000);	
}
